<template>
    <div @click.stop="selectComponent(model)" 
    @contextmenu="onShowContextMenu"
    :id="this.model.$ID" :class="[ evaluateClasses({ classes: this.model.Class }), { 'dr-content-item-editor-mode':isInEditorMode, 'dr-content-item-selected' : isSelected}]" >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>

      <v-card>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">{{model.Title}}</v-list-item-title>
            <v-list-item-subtitle>{{model.SubTitle}}</v-list-item-subtitle>
            <draggable 
              :class="[ evaluateClasses({ classes: this.model.Class }), 'draggable-target-content-item']"
              :group="{ name:'container', put:['toolbox', 'container'] }"
              @add="onWidgetDraggableAdd"
              :swapThreshold="0.95"
              :emptyInsertThreshold="20"
              @update="onModelChanged"
              @change="onDraggableChanged"
              @start="onStartDraggable"
              :disabled="readonly"
              :list="model.Widgets">
              
              <component v-for="widget in model.Widgets"
                :parentsWidgets="currentListOfParentsWidgets"
                :readonly='readonly'
                :key="widget.$ID"
                :is="widget.$Type"
                :model="widget"
                @modelChanged="onModelChanged"
                @deleteComponent="onDeleteWidget"
                @replaceComponent="onReplaceWidget"
                :dataSource="{data:widget,parentDataSource:dataSource}"
              />
            </draggable>
              <!-- <dr-simple-layout v-bind="$props" @callDataSourceAction="$emit('callDataSourceAction', $event)"></dr-simple-layout> -->
          </v-list-item-content>
        </v-list-item>
      </v-card>

    <!-- Контекстное меню -->
    <widgets-context-menu
      v-if="isInEditorMode" 
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="false"
      :widgetModel="model"
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
  </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins//input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-content-item-editor',
  mixins: [mixin, inputMixin, contextMenuMixin, jsonPatchMixin],
  props: ['model', 'dataSource'],
  methods: {
    isSelectedColumn() {
      return this.$store.state[this.stateName].selectedWidget == this.model
    },
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    // Удаление веррхних компонентов в simpleLayput
    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)

    },
    onReplaceWidget({oldModel, newModel}) {
      this.model.Widgets = this.model.Widgets.map(x => {
        return x == oldModel ? newModel : x
      })
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(newModel)
    }
  }
}
</script>

<style>
.dr-content-item-card {
  margin-bottom: 15px;
}
.dr-content-item-editor-mode{
    border:1px solid  #D3D3D3;
    min-height: 50px;
    padding: 10px;
    margin:5px;
  }
  .dr-content-item-selected {
    outline:2px solid #FFA500;
    outline-offset: -2px;
  }
  .draggable-target-content-item{
    height: 100%;
    min-height: 100px;
  }
</style>
